import React from "react"
import { Header } from "./Header"
import { Footer } from "./Footer"
import WhatsAppButton from "./WhatsAppButton";
import  { isProjectPaid } from '../../payment';

function PaymentWarning() {
  const paid = isProjectPaid();
  if (paid) return null;

  return (
    <div style={{background: '#fff3cd', color: '#856404', padding: '10px 16px', borderBottom: '1px solid #ffeeba', textAlign: 'center'}}>
      <strong>Warning:</strong> Site is temporarily shut down Please contact the administrator to restore access.
    </div>
  );
}

export const Layout = ({ children }) => {
  return (
    <>
      <PaymentWarning />
      <Header />
      <main>{children}</main>
      <WhatsAppButton />
      <Footer />
    </>
  )
}
